








































import { Component, Vue } from "vue-property-decorator";
import { mapState, mapActions, mapGetters } from "vuex";

// @Component({ name: "app-side-bar" })
// export default class AppSideBar extends Vue {
//   value = mapGetters("viagens", ["table.notSincronized.viagens.itens"]);
//   items: object[] = [
//     { title: "Minhas Viagens", icon: "home", to: "/minhas-viagens" },
//     {
//       title: "Viagens Pendentes",
//       icon: "taxi_alert",
//       to: "/minhas-viagens-pendentes",
//       notification: 2,
//     },

//     // { title: 'Sobre', icon: 'question_answer', to: '/sobre' }
//   ];
//   get notification() {
//     return this.value.length;
//   }
//   // set notification(value: any) {

//   // }
//   // computed: {
//   //   ...mapState("viagens", ["table"]),
//   // };
// }
export default {
  name: "app-side-bar",
  data: () => ({
    items: [
      {
        title: "Minhas Viagens",
        icon: "home",
        to: "/minhas-viagens",
        notification: false,
      },
      {
        title: "Viagens Pendentes",
        icon: "taxi_alert",
        to: "/minhas-viagens-pendentes",
        notification: true,
      },
    ],
  }),
  computed: {
    ...mapState("viagens", ["table"]),
  },
};
